import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomersType } from '@cargos/sprintpay-models';
import { RedirectionScreenComponent } from 'src/app/shared/components/redirection-screen/redirection-screen.component';
import { CustomerTypeGuard } from 'src/app/shared/guards';
import { AuthGuard } from '../../shared/guards/sign-in.guard';
import { FacilityInformationComponent, SearchAwbComponent } from './pages';
import { LoginComponent } from './pages/auth/login/login.component';
import { RecoverPasswordComponent } from './pages/auth/recover-password/recover-password.component';
import { ResetPasswordComponent } from './pages/auth/reset-password/reset-password.component';
import { ConfirmationAllianceComponent } from './pages/cart/confirmation-alliance/confirmation-alliance.component';
import { TermsofuseComponent } from './pages/termsofuse/termsofuse.component';

const routes: Routes = [
    {
        path: 'search-awb',
        pathMatch: 'full',
        component: SearchAwbComponent,
    },
    {
        path: 'search-awb/login/sso',
        pathMatch: 'full',
        component: RedirectionScreenComponent,
    },
    {
        path: 'search-awb/details',
        loadChildren: () =>
            import('./pages/search-awb/search-awb-details/awb-status.module').then((m) => m.AWBStatusModule),
    },
    {
        path: 'search-flight/details',
        loadChildren: () =>
            import('./pages/search-awb/search-flight-number/search-flight-number.module').then(
                (m) => m.SearchFlightNumberModule
            ),
    },
    {
        path: 'cart',
        loadChildren: () => import('./pages/cart/cart.module').then((m) => m.CartAllianceModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'cart/payment-method',
        loadChildren: () =>
            import('./pages/cart/guest-payment-method-component/guest-payment-method.module').then(
                (m) => m.GuestPaymentMethodAllianceModule
            ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'cart/echeck',
        loadChildren: () =>
            import('../../shared/modules/echeck-guest/echeck-payment-method.module').then(
                (m) => m.EcheckPaymentMethodModule
            ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'cart/echeck-user',
        loadChildren: () =>
            import('../../shared/modules/cart/payment-methods/method-echecks/echecks.module').then(
                (m) => m.EchecksModule
            ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'cart/credit-card',
        loadChildren: () =>
            import('../../shared/modules/cart/payment-methods/method-credit-cards/credit-cards.module').then(
                (m) => m.CreditCardsModule
            ),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'cart/confirmation',
        component: ConfirmationAllianceComponent,
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'payment-history',
        loadChildren: () =>
            import('./pages/payment-history/payment-history.module').then((m) => m.PaymentHistoryAllianceModule),
        data: {
            expectedCustomerTypes: [CustomersType.SALESFORCE_AUTHENTICATED],
        },
        canActivate: [CustomerTypeGuard, AuthGuard],
    },
    {
        path: 'facility-information',
        component: FacilityInformationComponent,
    },
    {
        path: 'login',
        component: LoginComponent,
        data: {
            expectedCustomerTypes: [CustomersType.GUEST, undefined, CustomersType.SALESFORCE_AUTHENTICATED],
            hideTitle: true,
        },
        canActivate: [CustomerTypeGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'recover-password',
        component: RecoverPasswordComponent,
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent,
    },
    {
        path: 'termsofuse',
        component: TermsofuseComponent,
    },
    {
        path: 'faq',
        loadChildren: () => import('../../shared/modules/faq/faq.module').then((m) => m.FAQModule),
    },
    {
        path: 'subscription',
        loadChildren: () =>
            import('./pages/auto-pay-subscription/auto-pay-subscription.module').then(
                (m) => m.AutoPaySubscriptionAllianceModule
            ),
        data: {
            expectedCustomerTypes: [CustomersType.SALESFORCE_AUTHENTICATED],
        },
        canActivate: [CustomerTypeGuard, AuthGuard],
    },
    {
        path: '**',
        redirectTo: 'search-awb',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'top',
        }),
    ],
    exports: [RouterModule],
})
export class AllianceRoutingModule {}
